import React, { useContext } from 'react';
import { UserContext } from '../UserContext/UserContext';
import unlog from '../../static/unlog.png';
import './navbarLoginComponent.css';

const NavbarLoginComponent = () => {
  const { userContext, logout } = useContext(UserContext);
  const { username } = userContext;

  return (
    <>
      {username !== '' ? (
        <li>
          <span>{username}</span>
        </li>
      ) : (
        <li>
          <a href="/login">Connexion</a>
        </li>
      )}
      {username !== '' && (
        <li>
          <div className="unlog">
            <div className="unlogButton">
              <img src={unlog} alt="Unlog" onClick={() => logout()}></img>
            </div>
          </div>
        </li>
      )}
    </>
  );
};

export default NavbarLoginComponent;
